import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';

const TranscriptDrawer = React.lazy(() => import('./TranscriptDrawer'));

export default function TranscriptDrawerContainer() {
  const isOpenTranscript = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.isOpenTranscript
  );
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );
  const isVideoOrAudio =
    selectedVersion?.metadata?.type === 'video' ||
    selectedVersion?.metadata?.type === 'audio';

  if (!isVideoOrAudio) return null;
  if (isOpenTranscript === null) return null;
  return (
    <Suspense fallback={null}>
      <TranscriptDrawer isOpenTranscript={!!isOpenTranscript} />
    </Suspense>
  );
}
